<ng-container *transloco="let t">
	<div class="is-flex is-justify-content-center">
		<img
			class="banner-image"
			style="max-width: 1200px; width: 100%"
			src="/images/banner.webp?v=20260401a" />
	</div>
	<div class="m-3">
		<div>
			<div class="title is-4 mb-0 pb-0">
				{{ t('content.pages.landingPage.location1') }}
			</div>
			<div
				class="mb-4 subtitle is-6"
				style="font-size: min(12px, 3.2vw); white-space: nowrap; overflow: hidden">
				{{ t('content.pages.landingPage.location2') }}
			</div>
			<div class="mb-2 mt-2">
				<fa-icon [icon]="icons.faMapPin" class="mr-2" />
				{{ t('content.pages.landingPage.venue') }}
			</div>
			<div class="mb-2">
				<fa-icon [icon]="icons.faCalendar" class="mr-2" />
				{{ t('content.pages.landingPage.date1') }}
			</div>
			<div class="mb-2">
				<fa-icon [icon]="icons.faCalendar" class="mr-2" />
				{{ t('content.pages.landingPage.date2') }}
			</div>
			<div>
				<div class="mb-5 is-inline-flex is-align-items-center">
					<fa-icon [icon]="icons.faTag" class="mr-2" />
					{{ t('content.pages.landingPage.freeOfCharge') }}
				</div>
			</div>
		</div>

		<div class="has-text-centered mb-4">
			<eventlyte-button
				label="{{ t('content.pages.landingPage.registerButton') }}"
				[color]="ViewColor.Dark"
				[size]="ViewSize.Medium"
				(click)="navigateToRegistration()"
				class="register-button"
				[icon]="icons.faCircleChevronRight"
				iconPosition="right" />
		</div>

		<hr />

		<div class="content mb-5">
			<h2 class="title is-4">
				{{ t('content.pages.landingPage.eventDetails.title') }}
			</h2>

			<p [innerHTML]="t('content.pages.landingPage.eventDetails.description')"></p>

			<div style="height: 250px">&nbsp;</div>
		</div>
	</div>
</ng-container>
